import React from "react"

function IconUsersGroup({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="users-group"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-users-group"
      {...props}
    >
      <path
        d="M8.688 2.182c2.145 0 3.971 1.323 4.662 3.177a4.155 4.155 0 0 1 3.363-1.686c2.282 0 4.131 1.798 4.131 4.017v2.42c0 1.075-.434 2.051-1.14 2.772l2.202.632a1.636 1.636 0 0 1 1.185 1.573v3.04c0 .904-.733 1.637-1.636 1.637h-5.16a2.183 2.183 0 0 1-2.135 1.727H3.25a2.182 2.182 0 0 1-2.18-2.182v-3.26c0-.976.646-1.833 1.584-2.1l2.463-.7A4.735 4.735 0 0 1 3.73 9.908V7.002c0-2.662 2.22-4.82 4.957-4.82zm2.242 12.026c-.608.3-1.288.482-2.008.514l-.234.005a5.053 5.053 0 0 1-2.208-.503l-3.468.985a.873.873 0 0 0-.626.724l-.008.115v3.261c0 .445.333.812.763.866l.11.007H14.16c.28 0 .529-.132.689-.337l.056-.08a.867.867 0 0 0 .12-.346l.008-.11v-3.266a.873.873 0 0 0-.512-.794l-.12-.044-3.471-.997zm7.34-.375a4.21 4.21 0 0 1-1.338.289l-.219.005c-.538 0-1.053-.1-1.525-.282l-.394.112.14.046a2.182 2.182 0 0 1 1.408 2.04v2.41l5.113.002a.327.327 0 0 0 .318-.253l.009-.075v-3.04a.327.327 0 0 0-.17-.287l-.067-.027-3.276-.94zM8.687 3.49c-1.953 0-3.535 1.473-3.642 3.313l-.006.198v2.905c0 1.864 1.515 3.402 3.414 3.506l.205.006.204-.005c1.878-.084 3.364-1.529 3.468-3.308l.006-.199V7.002c0-1.93-1.625-3.511-3.649-3.511zm4.425 8.59-.104.192c-.203.35-.45.672-.732.96l.134.039 1.326-.376a4.056 4.056 0 0 1-.488-.596l-.136-.218zm3.6-7.1c-1.504 0-2.721 1.126-2.816 2.532l-.006.177v2.42c0 1.428 1.157 2.61 2.606 2.703l.183.006.186-.005c1.437-.073 2.571-1.173 2.663-2.526l.006-.177V7.69c0-1.488-1.255-2.708-2.822-2.708z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconUsersGroup
